import { Context, useContext } from "react";

/**
 * Create a state hook
 */
export const createStateHook = <S>(stateContext: Context<S | undefined>) => {
  return (): S => {
    const state = useContext(stateContext);
    if (state === undefined) {
      throw new Error("useState must be used within a Provider");
    }

    return state;
  };
};
